var _instanceUrl = null;
var _site = null;
export function instanceUrl() {
  return _instanceUrl;
}
export function site() {
  return _site;
}
export default {
  init: function init(instanceUrl, site) {
    _instanceUrl = instanceUrl;
    _site = site;
  }
};